module.exports = __webpack_public_path__ + "img/icon-success@2x.09e562cc.png";